export const blockIconsHardwareDnsNew = (
	<span className='material-symbols-outlined'>dns</span>
);
